
import navigation from "./navigation";

export default class Controller{
    constructor(pageInfo){
        this.pages = {
            obj: pageInfo,
            list: Object.keys( pageInfo ),
            currPage: '',
            nextPage: '',
        };
        this.leady = false;
        this.navi = new navigation( this.pages.list );
    }

    init(currPage){
        this.pages.currPage = this.pages.obj[currPage];
        if( this.pages.currPage.class.pageTl ) this.pages.currPage.class.pageTl.seek(0.3);
        this.pages.currPage.class.show();
        this.navi.set(currPage);
        this._bindEvent();
    }

    _change(key){
        this.pages.nextPage = this.pages.obj[key];
        if( this.pages.nextPage == this.pages.currPage ) return;

        this.leady = false;
        if( this.pages.currPage ){
            this.pages.currPage.class.hide();
        }
        else{
            this.pages.currPage.class.show();
        }


        this.navi.set(key);

        this.pages.currPage = this.pages.nextPage;
    }

    _hideComplete(){
        if( this.pages.nextPage.class.pageTl ) this.pages.nextPage.class.pageTl.seek(0);
        this.pages.nextPage.class.show();
    }

    _setDirection(di){
        let currIdx = this.pages.list.indexOf( this.pages.currPage.key );

        if( di == 'next'){
            if( this.pages.list.length - 1 <= currIdx ) return;
            currIdx++;
        }
        else{
            if( 0 >= currIdx ) return;
            currIdx--;
        }
        this._change( this.pages.list[ currIdx ]);
    }

    _triggerEvent(e){
        switch(e.type){
            case 'onComplete': {
                this.leady = true;
                break;
            }
            case 'hideComplete': {
                this._hideComplete();
                break;
            }
            case 'navigation': {
                this._change( e.currentTarget.getAttribute('data-key') );
                break;
            }
        }
    }

    _bindEvent(){
        let len;
        document.getElementById('container').addEventListener('onwheel' in document ? 'wheel' : 'mousewheel', (()=> {
            let deltax, deltay, lastmovedtime = 0;
            return (e) =>  {
                if( !this.leady ) return;

                deltax = e.deltaX !== undefined ? e.deltaX : e.wheelDeltaX || 0;
                deltay = e.deltaY !== undefined ? e.deltaY : e.wheelDeltaY !== undefined ? e.wheelDeltaY : e.detail || e.wheelDelta*-1;
                if( Math.abs(deltay) > 2 && new Date().getTime()-lastmovedtime > 100 ){
                    let direction = deltay > 0 ? 'next' : 'prev';
                    this._setDirection(direction);
                    lastmovedtime = new Date().getTime();
                }
                e.preventDefault();
            };
        })(), false);

        len = this.pages.list.length;
        while( len-- ){
            this.pages.obj[ this.pages.list[len] ].ele.addEventListener('onComplete', this._triggerEvent.bind(this) );
            this.pages.obj[ this.pages.list[len] ].ele.addEventListener('hideComplete', this._triggerEvent.bind(this) );
        }

        len = this.navi.eles.length ;
        while( len-- ) this.navi.eles[len].querySelector('button').addEventListener('navigation', this._triggerEvent.bind(this))
    }
}


// WEBPACK FOOTER //
// ./src/js/mainDeath/controller.js